<!-- Card.vue -->
<template>
    <div class="w-full flex flex-wrap items-between mt-0 tablet-lg:mt-2 py-2 tablet-lg:py-8">
        <a class="w-full tablet-lg:w-1/2"
            :class="{
                'pointer-events-none opacity-60 cursor-not-allowed': sold,
            }"
           :href="sold ? null : remaxLink"
           target="_blank"
           rel="noreferrer"
        >
            <div
                class="card-wrap w-full"
                :class="sold ? 'sold' : ''"
                v-on="sold ? {} : { mousemove: handleMouseMove, mouseenter: handleMouseEnter, mouseleave: handleMouseLeave }"
                ref="card"
            >
                <div
                    class="w-64 tablet-sm:w-5/6 desktop:w-128 h-36 tablet-sm:h-56 laptop-lg:h-72 desktop:h-80 mx-auto card relative mt-4 overflow-hidden rounded-xs transition-all duration-1000 ease-in-out"
                    :style="cardStyle"
                >
                    <div class="ribbon-container overflow-visible" v-if="status === 'P'">
                        <i><span class="text-subtitle text-white">Under Contract</span></i>
                        <i></i>
                        <i></i>
                        <i></i>
                        <i></i>
                    </div>
                    <div
                        v-if="sold"
                        :class="[
                            was_seller_agent ? 'bg-remax-blue' : 'bg-remax-red',
                            'absolute text-white text-center transform -rotate-45 uppercase tracking-wider z-10',
                            'top-2 tablet-sm:top-8 -left-14 tablet-sm:-left-14 w-40 tablet-sm:w-52',
                            'text-sm tablet-sm:text-xl py-0.5 tablet-sm:py-1'
                        ]"
                    >
                        {{ was_seller_agent ? 'Sold' : 'Sold' }}
                    </div>
                    <div class="card-bg" :style="[cardBgTransform, cardBgImage]"></div>
                    <div class="card-info w-full">
                        <div class="flex justify-between">
                            <!-- TODO this is not consistent and when it takes up two lines it looks bad. Fix the hide show.  -->
                            <h3 class="text-lg tablet-sm:text-xl laptop-sm:text-2xl text-white">{{ title }}</h3>
                            <h3 class="text-lg tablet-sm:text-2xl font text-white">{{ price }}</h3>
                        </div>
                        <p
                            class="text-base font-semibold leading-8 text-white hover:text-white flex items-center hover"
                        >
                            <span
                                class="text-base font-semibold leading-8 text-white hover:text-white flex items-center hover"
                                v-if="remaxLink !== ''"
                            >
                                Read More at Remax.com &nbsp;
                                <ArrowTopRightOnSquareIcon class="h-5 w-5 inline-block font-semibold stroke-2" />
                            </span>
                            &nbsp;
                        </p>
                    </div>
                </div>
            </div>
        </a>
        <div class="w-full tablet-lg:w-1/2 mx-auto">
            <div class="pl-2 tablet-sm:pl-6 py-2">
                <div class="mx-auto w-full">
                    <h2
                        class="text-lg tablet-lg:text-2xl desktop:text-3xl mt-2 mx-0 px-0 font-subtitle font-bold tracking-wide text-secondary-text"
                        :class="sold ? 'text-secondary-text' : 'text-primary-text'"
                    >
                        <span :class="sold ? 'text-secondary-text' : ''">{{ title }}</span>
                        <span v-if="sold" class="no-underline text-primary-text"
                        >&nbsp;- {{ was_seller_agent ? 'Sold!' : 'Sold!' }}</span>
                        <br />
                        <span class="text-xl" :class="sold ? 'text-secondary-text' : ''">
                            {{ cityState }}
                            <br />
                            {{ zip }}
                        </span>
                    </h2>

                    <p class="mt-2" :class="sold ? 'text-secondary-text' : 'text-primary-text'">
                        <!--                        919191 is secondary-text -->
                        <svg
                            class="inline-block"
                            :fill="sold ? '#919191' : '#000000'"
                            width="24px"
                            height="24px"
                            viewBox="0 0 512.00 512.00"
                            id="Layer_1"
                            enable-background="new 0 0 512 512"
                            xmlns="http://www.w3.org/2000/svg"
                            stroke="#000000"
                            stroke-width="0.00512"
                        >
                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <g>
                                    <path
                                        d="m496 320c0-13.1 0-239.28 0-248 0-8.836-7.164-16-16-16s-16 7.164-16 16v16h-416v-16c0-8.836-7.164-16-16-16s-16 7.164-16 16v248c-8.836 0-16 7.164-16 16v104c0 8.836 7.164 16 16 16h40c5.036 0 9.778-2.371 12.8-6.4l19.2-25.6h336l19.2 25.6c3.021 4.029 7.764 6.4 12.8 6.4h40c8.836 0 16-7.164 16-16v-104c0-8.836-7.164-16-16-16zm-32-71.39c-17.206-9.979-30.797-8.61-48-8.61v-32c0-26.467-21.533-48-48-48h-80c-12.284 0-23.501 4.644-32 12.261-8.499-7.617-19.716-12.261-32-12.261h-80c-26.467 0-48 21.533-48 48v32c-17.989 0-30.887-1.315-48 8.61v-128.61h416zm-336-8.61v-32c0-8.822 7.178-16 16-16h80c8.822 0 16 7.178 16 16v32zm144-32c0-8.822 7.178-16 16-16h80c8.822 0 16 7.178 16 16v32h-112zm-224 96c0-17.645 14.355-32 32-32h352c17.645 0 32 14.355 32 32v16h-416zm432 120h-16l-19.2-25.6c-3.021-4.029-7.764-6.4-12.8-6.4h-352c-5.036 0-9.778 2.371-12.8 6.4l-19.2 25.6h-16v-72h448z"
                                    ></path>
                                </g>
                            </g>
                        </svg>
                        {{ beds }} {{ beds === 1 ? "Bed" : "Beds" }}
                        <br class="block tablet-sm:hidden" />
                        <span class="hidden tablet-sm:inline px-2">|</span>
                        <svg
                            class="inline-block"
                            :fill="sold ? '#919191' : '#000000'"
                            height="24px"
                            width="24px"
                            version="1.1"
                            id="Layer_1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                            viewBox="0 0 512 512"
                            xml:space="preserve"
                            :stroke="sold ? '#919191' : '#000000'"
                            stroke-width="13.312000000000001"
                        >
                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <g transform="translate(1 1)">
                                    <g>
                                        <g>
                                            <path
                                                d="M485.4,272.067h-8.533v-179.2c0-42.667-34.133-76.8-76.8-76.8c-37.77,0-64.935,28.006-67.974,69.041 c-19.829,3.748-34.426,20.826-34.426,41.892c0,5.12,3.413,8.533,8.533,8.533h68.267c5.12,0,8.533-3.413,8.533-8.533 c0-20.833-14.274-37.769-33.767-41.767c2.55-27.116,18.836-52.1,50.834-52.1c33.28,0,59.733,26.453,59.733,59.733v179.2H202.975 c-3.86-19.681-20.878-34.133-41.841-34.133c-8.533-10.24-20.48-17.067-34.133-17.067c-16.213,0-30.72,9.387-37.547,23.04 c-6.827-3.413-14.507-5.973-22.187-5.973c-20.963,0-37.981,14.452-41.841,34.133H24.6c-14.507,0-25.6,11.093-25.6,25.6 c0,14.507,11.093,25.6,25.6,25.6h10.255l23.025,91.307c6.827,26.453,30.72,45.227,58.027,45.227h6.827l-11.093,22.187 c-2.56,4.267-0.853,9.387,3.413,11.093c0.853,0.853,2.56,0.853,3.413,0.853c3.413,0,5.973-1.707,7.68-4.267L141.08,459.8h236.8 l14.507,29.013c1.707,3.413,4.267,5.12,7.68,5.12c1.707,0,2.56,0,3.413-1.707c3.413-1.707,5.12-6.827,3.413-11.093 l-10.689-21.379c26.419-0.938,49.266-19.39,55.916-44.328l23.24-92.16h10.04c14.507,0,25.6-11.093,25.6-25.6 C511,283.16,499.907,272.067,485.4,272.067z M365.08,118.467h-48.64c3.413-10.24,13.653-17.067,24.747-17.067 S361.667,108.227,365.08,118.467z M67.267,255c7.68,0,14.507,3.413,20.48,9.387c1.707,2.56,5.12,3.413,8.533,2.56 s5.12-3.413,5.973-6.827c2.56-12.8,12.8-22.187,25.6-22.187c9.387,0,17.92,4.267,22.187,12.8c1.707,3.413,5.973,5.12,9.387,4.267 c0.853,0,1.707,0,2.56,0c11.093,0,20.48,6.827,23.893,17.067H43.373C46.787,261.827,56.173,255,67.267,255z M436.76,410.307 c-5.12,18.773-22.187,32.427-41.813,32.427H116.76c-19.627,0-36.693-13.653-41.813-32.427l-22.187-87.04h404.48L436.76,410.307z M485.4,306.2h-17.067H41.667H24.6c-5.12,0-8.533-3.413-8.533-8.533s3.413-8.533,8.533-8.533h8.533h162.133H485.4 c5.12,0,8.533,3.413,8.533,8.533S490.52,306.2,485.4,306.2z"
                                            ></path>
                                            <path
                                                d="M306.2,173.933c5.12,0,8.533-3.413,8.533-8.533v-4.267c0-5.12-3.413-8.533-8.533-8.533s-8.533,3.413-8.533,8.533v4.267 C297.667,170.52,301.08,173.933,306.2,173.933z"
                                            ></path>
                                            <path
                                                d="M306.2,213.187c5.12,0,8.533-4.267,8.533-8.533v-9.387c0-5.12-3.413-8.533-8.533-8.533s-8.533,3.413-8.533,8.533v9.387 C297.667,209.773,301.08,213.187,306.2,213.187z"
                                            ></path>
                                            <path
                                                d="M306.2,246.467c5.12,0,8.533-3.413,8.533-8.533v-4.267c0-5.12-3.413-8.533-8.533-8.533s-8.533,3.413-8.533,8.533v4.267 C297.667,243.053,301.08,246.467,306.2,246.467z"
                                            ></path>
                                            <path
                                                d="M340.333,173.933c5.12,0,8.533-3.413,8.533-8.533v-4.267c0-5.12-3.413-8.533-8.533-8.533 c-5.12,0-8.533,3.413-8.533,8.533v4.267C331.8,170.52,335.213,173.933,340.333,173.933z"
                                            ></path>
                                            <path
                                                d="M331.8,204.653c0,5.12,3.413,8.533,8.533,8.533c5.12,0,8.533-4.267,8.533-8.533v-9.387c0-5.12-3.413-8.533-8.533-8.533 c-5.12,0-8.533,3.413-8.533,8.533V204.653z"
                                            ></path>
                                            <path
                                                d="M331.8,237.933c0,5.12,3.413,8.533,8.533,8.533c5.12,0,8.533-3.413,8.533-8.533v-4.267c0-5.12-3.413-8.533-8.533-8.533 c-5.12,0-8.533,3.413-8.533,8.533V237.933z"
                                            ></path>
                                            <path
                                                d="M374.467,173.933c5.12,0,8.533-3.413,8.533-8.533v-4.267c0-5.12-3.413-8.533-8.533-8.533s-8.533,3.413-8.533,8.533v4.267 C365.933,170.52,369.347,173.933,374.467,173.933z"
                                            ></path>
                                            <path
                                                d="M365.933,204.653c0,5.12,3.413,8.533,8.533,8.533S383,208.92,383,204.653v-9.387c0-5.12-3.413-8.533-8.533-8.533 s-8.533,3.413-8.533,8.533V204.653z"
                                            ></path>
                                            <path
                                                d="M365.933,237.933c0,5.12,3.413,8.533,8.533,8.533s8.533-3.413,8.533-8.533v-4.267c0-5.12-3.413-8.533-8.533-8.533 s-8.533,3.413-8.533,8.533V237.933z"
                                            ></path>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </svg>
                        {{ baths }} {{ baths === 1 ? "Bath" : "Baths" }}
                        <br class="block tablet-sm:hidden" />
                        <span class="hidden tablet-sm:inline px-2">|</span>
                        <Square3Stack3DIcon class="h-6 w-6 inline-block" />
                        {{ sqft }} Sq Ft
                    </p>

                    <p v-if="description.length > 380"
                        class="mt-6 text-base leading-6 text-primary-text overflow-hidden max-h-32"
                        :class="sold ? 'text-secondary-text' : 'text-primary-text'"
                        >
                        {{ description.slice(0, 380).slice(0, description.slice(0, 380).lastIndexOf(' ')) }}... <a
                        class="w-full tablet-lg:w-1/2" v-if="!sold"
                           :class="{
                                'pointer-events-none opacity-60 cursor-not-allowed': sold,
                            }"
                           :href="sold ? null : remaxLink"
                           target="_blank"
                           rel="noreferrer"
                        >Click to read more at Remax.com
                        </a>
                    </p>
                    <p v-else
                       class="mt-6 text-base leading-6 text-primary-text overflow-hidden max-h-32"
                       :class="sold ? 'text-secondary-text' : 'text-primary-text'"
                    >
                        {{ description }}
                    </p>
<!--                    <dl class="mt-16 grid max-w-xl grid-cols-1 gap-8 sm:mt-20 sm:grid-cols-2 xl:mt-16">-->
<!--                        <div-->
<!--                            v-for="stat in stats"-->
<!--                            :key="stat.id"-->
<!--                            class="flex flex-col gap-y-3 border-l border-accent pl-6"-->
<!--                        >-->
<!--                            <dt class="text-sm leading-6 text-gray-600">{{ stat.name }}</dt>-->
<!--                            <dd class="order-first text-3xl font-semibold tracking-tight text-gray-900">-->
<!--                                {{ stat.value }}-->
<!--                            </dd>-->
<!--                        </div>-->
<!--                    </dl>-->
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { Link } from "@inertiajs/vue3";
import {  Square3Stack3DIcon, ArrowTopRightOnSquareIcon } from "@heroicons/vue/24/outline";
import Home from "@/Pages/Home.vue";

const props = defineProps({
    dataImage: {
        type: String,
        required: true,
    },
    title: {
        type: String,
        required: true,
    },
    beds: {
        type: String,
        required: true,
    },
    baths: {
        type: String,
        required: true,
    },
    sqft: {
        type: String,
        required: true,
    },
    price: {
        type: String,
        required: true,
    },
    cityState: {
        type: String,
        required: true,
    },
    zip: {
        type: String,
        required: true,
    },
    description: {
        type: String,
        required: true,
    },
    sold: {
        type: Boolean,
        required: true,
    },
    status: {
        type: String,
        required: true,
    },
    remaxLink: {
        type: String,
        required: true,
    },
    was_seller_agent: {
        type: Boolean,
        required: true,
    },
});

const card = ref(null);
const width = ref(0);
const height = ref(0);
const mouseX = ref(0);
const mouseY = ref(0);
const mouseLeaveDelay = ref(null);

onMounted(() => {
    width.value = card.value.offsetWidth;
    height.value = card.value.offsetHeight;
    mouseX.value = width.value / 2;
    mouseY.value = height.value / 2;
});

const mousePX = computed(() => (mouseX.value / width.value) * 2 - 1);
const mousePY = computed(() => (mouseY.value / height.value) * 2 - 1);

const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

const cardStyle = computed(() => {
    const rX = mousePX.value * 10;
    const rY = mousePY.value * -10;
    return {
        transform: `rotateY(${rX}deg) rotateX(${rY}deg)`,
    };
});

const cardBgTransform = computed(() => {
    const tX = clamp(mousePX.value * -20, -20, 20); // Clamped to prevent excessive movement
    const tY = clamp(mousePY.value * -20, -20, 20); // Clamped to prevent excessive movement
    return {
        transform: `translateX(${tX}px) translateY(${tY}px)`,
    };
});

const cardBgImage = computed(() => ({
    backgroundImage: `url(${encodeURI(props.dataImage)})`,
}));

const handleMouseMove = (e) => {
    const rect = card.value.getBoundingClientRect();
    mouseX.value = e.clientX - rect.left;
    mouseY.value = e.clientY - rect.top;
};

const handleMouseEnter = () => {
    clearTimeout(mouseLeaveDelay.value);
};

const handleMouseLeave = () => {
    mouseLeaveDelay.value = setTimeout(() => {
        mouseX.value = width.value / 2;
        mouseY.value = height.value / 2;
    }, 300);
};
</script>

<style scoped>
.card-wrap {
    margin: 10px 0px;
    transform: perspective(800px);
    transform-style: preserve-3d;
    cursor: pointer;
}

.card-wrap:hover:not(.sold) .card-info {
    transform: translateY(0);
}

.card-wrap:hover .card-info p {
    opacity: 1;
}

.card-wrap:hover .card-info,
.card-wrap:hover .card-info p {
    transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1);
}

.card-wrap:hover .card-info:after {
    transition: 5s cubic-bezier(0.23, 1, 0.32, 1);
    opacity: 1;
    transform: translateY(0);
}

.card-wrap:hover .card-bg {
    transition:
        0.6s cubic-bezier(0.23, 1, 0.32, 1),
        opacity 5s cubic-bezier(0.23, 1, 0.32, 1);
    opacity: 0.95;
}

/*// accent rgba(213, 185, 178, 0.66)*/

.card-bg {
    opacity: 0.8;
    position: absolute;
    top: -20px;
    left: -20px;
    width: calc(100% + 40px);
    height: calc(100% + 40px);
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    transition:
        1s cubic-bezier(0.445, 0.05, 0.55, 0.95),
        opacity 5s 1s cubic-bezier(0.445, 0.05, 0.55, 0.95);
    pointer-events: none;
}

.card-info {
    padding: 20px;
    position: absolute;
    bottom: 0;
    color: #fff;
    transform: translateY(40%);
    transition: 0.6s 1.6s cubic-bezier(0.215, 0.61, 0.355, 1);
}

.card-info p {
    opacity: 0;
    text-shadow: rgba(0, 0, 0, 1) 0 2px 3px;
    transition: 0.6s 1.6s cubic-bezier(0.215, 0.61, 0.355, 1);
}

.card-info * {
    position: relative;
    z-index: 1;
}

.card-info:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(to bottom, transparent 0%, rgba(0, 0, 0, 0.6) 100%);
    background-blend-mode: overlay;
    opacity: 0;
    transform: translateY(100%);
    transition: 2s 1s cubic-bezier(0.445, 0.05, 0.55, 0.95);
}

.card-info h1 {
    font-family: "Playfair Display";
    font-size: 36px;
    font-weight: 700;
    text-shadow: rgba(0, 0, 0, 0.5) 0 10px 10px;
}

/* Ribbon styling for the pending banner */
.ribbon-container {
    width: 200px;
    height: 30px;
    margin: 5px auto 0px;
    top: 0px;
    position: relative;
    text-align: center;
    text-transform: uppercase;
}
.ribbon-container i:first-child {
    background: #df001f;
    color: #fff;
    top: 0px;
    left: 0px;
    width: 200px;
    height: 30px;
    font: 16px/30px sans-serif;
    position: absolute;
    z-index: 99;
}
.ribbon-container i {
    position: absolute;
}

.ribbon-container i:nth-child(2), .ribbon-container i:nth-child(3) {
    position: absolute;
    left: -10px;
    bottom: -10px;
    z-index: 90;
    border: 10px solid transparent;
    border-right-color: #5c000d;
}

.ribbon-container i:nth-child(3) {
    left: auto;
    right: -10px;
    z-index: 90;
    border-right-color: transparent;
    border-left-color: #5c000d;
}

.ribbon-container i:nth-child(4), .ribbon-container i:last-of-type {
    width: 20px;
    bottom: -10px;
    left: -20px;
    z-index: 80;
    border: 15px solid #a30019;
    border-left-color: transparent;
}

.ribbon-container i:last-of-type {
    bottom: -10px;
    left: auto;
    right: -20px;
    border: 15px solid #a30019;
    border-right-color: transparent;
    z-index: 80;
}

@media (min-width: 768px) {
    .card-wrap:hover .card {
        transition:
            0.6s cubic-bezier(0.23, 1, 0.32, 1),
            box-shadow 2s cubic-bezier(0.23, 1, 0.32, 1);
        box-shadow:
            rgba(0, 0, 0, 0.2) 0 0 40px 5px,
            rgba(255, 255, 255, 1) 0 0 0 1px,
            rgba(0, 0, 0, 0.66) 0 30px 60px 0,
            inset #dbb 0 0 0 5px,
            inset #d5b9b2 0 0 0 6px;
    }
    .card {
        flex: 0 0 240px;
        background-color: #333;
        box-shadow:
            rgba(0, 0, 0, 0.66) 0 30px 60px 0,
            inset #dbb 0 0 0 5px,
            inset rgba(255, 255, 255, 0.5) 0 0 0 6px;
        transition: 1s cubic-bezier(0.445, 0.05, 0.55, 0.95);
        z-index: 20;
    }
}

@media (min-width: 1441px) {

    /* Ribbon styling for the pending banner */
    .ribbon-container {
        width: 420px;
        height: 40px;
        margin: 10px auto 0px;
    }
    .ribbon-container i:first-child {
        top: 0px;
        left: 0px;
        width: 420px;
        height: 40px;
        font: 24px/40px sans-serif;
    }
    .ribbon-container i {
        position: absolute;
    }

    .ribbon-container i:nth-child(2), .ribbon-container i:nth-child(3) {
        left: -20px;
        bottom: -20px;
        z-index: 90;
        border: 20px solid transparent;
        border-right-color: #5c000d;
    }

    .ribbon-container i:nth-child(3) {
        left: auto;
        right: -20px;
        z-index: 90;
        border-right-color: transparent;
        border-left-color: #5c000d;
    }

    .ribbon-container i:nth-child(4), .ribbon-container i:last-of-type {
        width: 20px;
        bottom: -20px;
        left: -30px;
        z-index: 80;
        border: 25px solid #a30019;
        border-left-color: transparent;
    }

    .ribbon-container i:last-of-type {
        bottom: -20px;
        left: auto;
        right: -30px;
        border: 25px solid #a30019;
        border-right-color: transparent;
        z-index: 80;
    }
}
</style>
